<template>
    <div class="editable-select single">
        <div class="text" :id="id">{{ selectedItem ? selectedItem[selector] : '&nbsp;' }}</div>
        <div ref="template" class="template">
            <div class="row">
                <div class="col-md-12">
                    <v-select
                        ref="dropdown"
                        :reduce="item => item.id"
                        :label="selector"
                        :options="options"
                        @input="updated"
                        v-model="selected"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css';

    export default {
        props: {
            id: {
                type: String,
                default() {
                    return `tooltip-${this._uid}`;
                },
            },
        },
        data() {
            return {
                tooltip: null,
                selected: this.$parent.selectedMutable,
                selector: this.$parent.selector,
                options: this.$parent.options,
            }
        },
        mounted() {
            this.tooltip = tippy(`#${this.id}`, {
                allowHTML: true,
                content: this.$refs.template,
                trigger: 'click',
                interactive: true,
                placement: 'bottom',
            });
        },
        methods: {
            updated() {
                this.$emit('update', this.selected);
                this.closeTooltip();
            },
            closeTooltip() {
                this.tooltip[0].hide();
            },
        },
        computed: {
            selectedItem() {
                return _.find(this.options, (item) => {
                    return parseInt(item.id) === parseInt(this.selected);
                });
            }
        }
    }
</script>

<style scoped>
.editable-select .text {
    border-bottom: 1px dashed #aaa;
    cursor: pointer;
}

.editable-select .v-select {
    background: #fff;
    min-width: 15vw;
    color: #333;
}
</style>
